import { ColumnData, SlideAction, ViewMode } from '@gripp/shared-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { RoutinePreviewColumn } from '../../new-routines/components/routinePreviewColumn';
import { Routines } from './routines';

export const RoutinePreview = () => {
  const { routineId } = useParams<{ routineId: string }>();
  const navigate = useNavigate();

  if (!routineId) {
    return null;
  }

  const rightColumn: ColumnData = {
    title: 'routine.list.routines',
    mainComponent: <RoutinePreviewColumn basePath="/routines" />,
    showBackButton: true,
    disableScroll: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => {
      navigate('/routines');
    },
  };

  return <Routines rightColumn={rightColumn} viewMode={ViewMode.DUAL} />;
};
